import { trpc } from "@/lib/api/trpc";

export interface BusinessConfig {
  houseTipPercentage: number;
}

/**
 * Hook to fetch business configuration from the backend
 * This ensures configuration is centralized and consistent across deployments
 */
export function useBusinessConfig() {
  // @ts-ignore - tRPC type issues
  const { data, isLoading, error } = trpc.config.getBusinessConfig.useQuery(
    undefined,
    {
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
      refetchOnWindowFocus: false, // Don't refetch on window focus
    },
  );

  return {
    houseTipPercentage: data?.houseTipPercentage ?? 0.09, // Fallback to 9%
    isLoading,
    error,
  };
}